import { render, staticRenderFns } from "./SuratJalanDeliverySubconDetailUpload.vue?vue&type=template&id=12de0518&"
import script from "./SuratJalanDeliverySubconDetailUpload.vue?vue&type=script&lang=js&"
export * from "./SuratJalanDeliverySubconDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports